// Two views of one trip (owner, 2026-11-04): "Your trip at a glance", the main one, and the calendar — the
// invitation to arrange it by hand. A big switch on both, back and forth; what is changed on one is on the other.
import { LayoutGrid, CalendarDays } from "lucide-react";

export default function ViewSwitch({ view, onGlance, onCalendar, busy = false }) {
  const side = (key, Icon, title, line, onClick) => {
    const on = view === key;
    return (
      <button onClick={on ? undefined : onClick} disabled={busy && !on} aria-pressed={on} data-testid={`view-${key}`}
        className="flex-1 min-w-0 flex items-center gap-3 px-4 py-3 rounded-lg text-left transition-colors disabled:opacity-60"
        style={{ background: on ? "var(--zen-text)" : "transparent", color: on ? "var(--zen-bg)" : "var(--zen-text)", cursor: on ? "default" : "pointer" }}>
        <Icon className="w-5 h-5 shrink-0" style={{ color: on ? "var(--zen-bg)" : "var(--zen-accent)" }} />
        <span className="min-w-0">
          <span className="block text-[15px] font-semibold leading-tight">{title}</span>
          <span className="block text-[12px] leading-snug mt-0.5" style={{ opacity: 0.75 }}>{line}</span>
        </span>
      </button>
    );
  };
  return (
    <div className="flex gap-1 p-1 rounded-xl w-full" style={{ background: "var(--zen-s1)", border: "1px solid var(--zen-border)" }}
      role="group" aria-label="How you see your trip" data-testid="view-switch">
      {side("glance", LayoutGrid, "Your trip at a glance", "Every city and every place", onGlance)}
      {side("calendar", CalendarDays, "See it as a calendar", busy ? "Laying out your days..." : "Arrange it by hand, day by day, your way", onCalendar)}
    </div>
  );
}
